<div layout-centered layout-vertical>
  <div class="sign"></div>
  <span class="heading">{{ 'rto.common.page_not_found.title' | translate }}</span>
  <span class="subheading">{{ 'rto.common.page_not_found.desc' | translate }}</span>
  <a rt-button variant="tertiary" [href]="appAuthUrl">{{
    'rto.common.page_not_found.button' | translate
  }}</a>
</div>
